module.exports = function() {
  return new Worker(__webpack_public_path__ + "fcffcb174b6273a4a56c.worker.js");
};